import {useMemo} from 'react';

import {envIsLocal} from '../../../../config';
import {useProjectAccessQuery} from '../../../../generated/graphql';

// these are private values on the `access` property on a Project
// see: https://weightsandbiases.slack.com/archives/CR1B10HFW/p1686341646769249
export const privateAccessKeys = ['PRIVATE', 'ENTITY_READ', 'ENTITY_WRITE'];

export function useRelaxedMarkdownToHTML(
  entityName: string,
  projectName: string,
  // injected functionality for testing
  isLocalEnv: boolean = envIsLocal,
  queryProjectAccess: typeof useProjectAccessQuery = useProjectAccessQuery
) {
  const isPrivateProject = (accessKey: string) =>
    privateAccessKeys.includes(accessKey.toUpperCase());

  const {loading, data} = queryProjectAccess({
    variables: {
      entityName,
      name: projectName,
    },
  });

  const isProjectPrivate = isPrivateProject(data?.project?.access ?? '');

  /**
   * Current business rules are that we can relax some HTML sanitation when
   * we know that we are in a local environment and a private project
   * see: https://wandb.atlassian.net/browse/WB-12729
   */
  return useMemo(() => {
    return !loading && isProjectPrivate && isLocalEnv;
  }, [isProjectPrivate, isLocalEnv, loading]);
}
